import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import { getFirestore } from 'firebase/firestore';

const conexion = firebase.initializeApp({
        apiKey:  process.env.REACT_APP_FIRESBASE_APIKEY,
        authDomain:  process.env.REACT_APP_FIRESBASE_AUTHDOMAIN,
        projectId:  process.env.REACT_APP_FIRESBASE_PROJECTID,
        storageBucket:  process.env.REACT_APP_FIRESBASE_STORAGEBUCKET,
        messagingSenderId:  process.env.REACT_APP_FIRESBASE_MESSAGINGSENDERID,
        appId:  process.env.REACT_APP_FIRESBASE_APPID,
        measurementId: process.env.REACT_APP_FIRESBASE_MEASUREMENTID
});

export const auth = firebase.auth();
export const db_firestore = getFirestore(conexion);
export const db_realtimedb = firebase.database();
export default conexion;